import React from "react";
import { object } from "prop-types";
import { Link } from "@quintype/components";

import { LabelWithBackground } from "../../atoms/label";

import "./program-themes.m.css";

const ProgramThemes = ({ story }) => {
  if (!story.tags || !story["linked-entities"]) {
    return null;
  }

  // Get the tag id matching the condition
  const tagIdList = story.tags.filter(item => item["tag-type"] === "Entity").map(item => item.id);
  // Get all the entities whose tag id matches to it
  const completedTag = story.tags.filter(item => item["name"] === "Completed" || item["name"] === "completed");
  const entityList = story["linked-entities"].filter(item => tagIdList.includes(item.id));
  const tagList = entityList.concat(completedTag);
  if (!(tagList && tagList.length)) {
    return null;
  }

  return (
    <div styleName="wrapper" className="program-themes-wrapper">
      {tagList.map((item, index) => (
        <Link key={index} href={`/topic/${item.slug}`}>
          <LabelWithBackground text={item.name} />
        </Link>
      ))}
    </div>
  );
};

ProgramThemes.propTypes = {
  story: object.isRequired
};

export default ProgramThemes;
